export default __webpack_public_path__ + "static/media/buying-thumb-v1.3af3150a.jpg";